import React from 'react';
import { Box, Typography, Card, CardContent, Grid, IconButton, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const AnalysisKPICards = ({ 
  analysisData, 
  selectedClient, 
  isCurrentMonthSelected // boolean値として受け取る
}) => {
  if (!analysisData) return null;

  // 🔧 修正：月平均の表示判定
  const shouldShowAverage = analysisData.allTimeMonthlyAverage > 0;
  const isDataInsufficient = analysisData.dataStartPeriod?.includes('データ不足') || 
                           analysisData.dataStartPeriod?.includes('データなし');

  return (
    <Grid container spacing={3}>
      {/* 期間内総供給量 */}
      <Grid item xs={12} md={4}>
        <Card elevation={2} sx={{ borderRadius: 2, height: 200 }}>
          <CardContent sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center' 
          }}>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              {isCurrentMonthSelected ? '今月の総供給量' : '期間内総供給量'}
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 600, color: 'primary.main' }}>
              {analysisData.totalAmount?.toLocaleString()}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {analysisData.productUnit || 'リットル'}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ 
              mt: 1, 
              display: 'block', 
              minHeight: '32px' 
            }}>
              {selectedClient 
                ? `顧客: ${selectedClient.name}` 
                : (isCurrentMonthSelected ? '今月の実績' : '選択期間内の実績')
              }
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* 🔧 修正：月平均表示 */}
      <Grid item xs={12} md={4}>
        <Card elevation={2} sx={{ borderRadius: 2, height: 200 }}>
          <CardContent sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center' 
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
              <Typography variant="h6" color="text.secondary">
                月平均供給量
              </Typography>
              <Tooltip title={analysisData.dataStartPeriod}>
                <IconButton size="small">
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            
            {/* データ不足時の表示 */}
            {isDataInsufficient ? (
              <>
                <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.disabled' }}>
                  —
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  データ不足
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="h3" sx={{ 
                  fontWeight: 600, 
                  color: shouldShowAverage ? 'success.main' : 'text.disabled' 
                }}>
                  {shouldShowAverage ? Math.round(analysisData.allTimeMonthlyAverage || 0).toLocaleString() : '—'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {shouldShowAverage ? `${analysisData.productUnit || 'リットル'}/月` : 'データ不足'}
                </Typography>
              </>
            )}
            
            <Typography variant="caption" color="text.secondary" sx={{ 
              mt: 1, 
              display: 'block', 
              minHeight: '32px',
              fontSize: '0.7rem'
            }}>
              {analysisData.dataStartPeriod}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* 供給顧客数 */}
      <Grid item xs={12} md={4}>
        <Card elevation={2} sx={{ borderRadius: 2, height: 200 }}>
          <CardContent sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center' 
          }}>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              {selectedClient ? '対象顧客' : '供給顧客数'}
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 600, color: 'warning.main' }}>
              {selectedClient ? '1' : (analysisData.suppliedClientCount || 0)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              顧客
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ 
              mt: 1, 
              display: 'block', 
              minHeight: '32px' 
            }}>
              {isCurrentMonthSelected ? '今月供給実績' : '選択期間内'}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AnalysisKPICards;